<body class="home">
     
    <div id="page" class="page">
       <!-- site header html start  -->
       <app-smart-header></app-smart-header>
       <div #home></div>
       <!-- site header html end  -->
       <main id="content" class="site-main">
          <!-- ***home banner html start form here*** -->
          <section class="home-banner-section home-banner-slider">
             <div class="home-banner d-flex flex-wrap align-items-center" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/e443a991-6970-45da-f5f4-4551c157c100/public);">
                <div class="overlay"></div>
                <div class="container">
                   <div class="banner-content text-center">
                      <div class="row">
                         <div class="col-lg-8 offset-lg-2">
                            <h1 class="banner-title">VOYJALEAS</h1>
                            <p>Servicio de consultoría para viajar, estudiar, trabajar o vivir en España.                            </p>
                            <div class="banner-btn">
                               <a href="javascript: void(0)" class="round-btn" (click)="scrollToElement('packsoffer')">Me interesa</a>
                               <a href="javascript: void(0)" (click)="buyProductSimple('videocall60')" class="outline-btn outline-btn-white">Videollamada inicial</a>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
             
          </section>
      
          <!-- ***search search field html end here*** -->
          <!-- ***Home destination html start from here*** -->
          <section class="home-destination">
             <div class="container">
                <div class="row">
                   <div class="col-lg-8 offset-lg-2 text-sm-center">
                      <div class="section-heading">
                         <h5 class="sub-title">ES TU MOMENTO DE</h5>
                         <h2 class="section-title">DAR EL SALTO A EUROPA</h2>
                         <p>En VoyJaleas, nos especializamos en convertir sueños en realidades para aquellos que aspiran a explorar, estudiar, trabajar o vivir en Europa.
                         </p>
                         <p>
                           Con más de 5 años de experiencia, somos tu aliado clave en proporcionar orientación experta, recursos actualizados y asesoramiento personalizado en cada paso de tu viaje
                         </p>
                      </div>
                   </div>
                </div>
                <div class="destination-section">

                  <!-- Photo by <a href="https://unsplash.com/@glenncarstenspeters?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Glenn Carstens-Peters</a> on <a href="https://unsplash.com/photos/person-writing-bucket-list-on-book-RLw-UC03Gwc?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                   <div class="row">
                      <div class="col-lg-4 col-md-6">
                         <article class="destination-item" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/f403f0f2-e998-4423-6ccf-c0f60d50cc00/public)">
                            <div class="destination-content">
                               <div class="rating-start-wrap">
                                 <i class="fa fa-search myicon"></i>
                               </div>
                               <!-- <span class="cat-link">
                                  <a href="destination.html">ITALY</a>
                               </span> -->
                               <h3>
                                  <a href="javascript: void(0)">ASISTENCIA PREVIA A TU SALIDA</a>
                               </h3>
                               <!-- <p>Fusce hic augue velit wisi ips quibusdam pariatur, iusto.</p> -->
                            </div>
                         </article>
                      </div>

                      <!-- Photo by <a href="https://unsplash.com/@linkedinsalesnavigator?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">LinkedIn Sales Solutions</a> on <a href="https://unsplash.com/photos/man-writing-on-white-paper-EI50ZDA-l8Y?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                      <div class="col-lg-4 col-md-6">
                         <article class="destination-item" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3f3a9f2b-689d-4cba-64c8-edf3dd604100/public);">
                            <div class="destination-content">
                               <div class="rating-start-wrap">
                                 <i class="fa fa-clipboard-check myicon"></i>
                               </div>
                               <!-- <span class="cat-link">
                                  <a href="destination.html">Dubai</a>
                               </span> -->
                               <h3>
                                  <a href="javascript: void(0)">GUÍA DURANTE TODOS LOS TRÁMITES</a>
                               </h3>
                               <!-- <p>Fusce hic augue velit wisi ips quibusdam pariatur, iusto.</p> -->
                            </div>
                         </article>
                      </div>

                      <!-- Photo by <a href="https://unsplash.com/@ross_savchyn?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Rostyslav Savchyn</a> on <a href="https://unsplash.com/photos/woman-in-white-crew-neck-t-shirt-standing-on-the-street-ekBNBaVGqsA?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                      <div class="col-lg-4 col-md-6">
                         <article class="destination-item" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/8e9766bb-15d7-490e-5412-44eb98433400/public);">
                            <div class="destination-content">
                               <div class="rating-start-wrap">
                                 <i class="fa fa-plane-arrival myicon"></i>
                               </div>
                               <!-- <span class="cat-link">
                                  <a href="destination.html">Seguimiento/asistencia</a>
                               </span> -->
                               <h3>
                                  <a href="javascript: void(0)">LLEGADA Y ADAPTACIÓN</a>
                               </h3>
                               <!-- <p>Te ayudaremos en los primeros meses de adaptación.</p> -->
                            </div>
                         </article>
                      </div>
                   </div>
                   <div class="section-btn-wrap text-center">
                      <a href="javascript: void(0)" class="round-btn" (click)="goToPage('services')">Todos los servicios</a>
                   </div>
                </div>
             </div>
             <!-- Reference to packs offer scroll to -->
             <div #packsoffer></div>
          </section>

          <div #how></div>
          <div class="inner-career-detail-wrap">
            <div class="container">
               <div class="row" >
                  <div class="col-lg-8 offset-lg-2 text-sm-center">
                     <div class="section-heading">
                        <h5 class="sub-title">¿CÓMO FUNCIONA NUESTRA CONSULTORÍA?</h5>
                        <h2 class="section-title">ASÍ TE AYUDAREMOS</h2>
                        <p>Te guiaremos durante todos los procesos y requisitos que debes complir para hacer de tu experiencia lo más tranquila y organizada posible.</p>
                        <p>Además te brindaremos la información just en  elmomento en que la necesitás para evitar perder tiempo innecesariamente.</p>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-5">
                     <figure class="career-detail-image">
                        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/9c4952ea-0229-4c0f-e305-3a5c69a9e500/public">
                     </figure>
                  </div>
                  <div class="col-md-7">
                     <div class="tab-section">
                        <div class="tab-container">
                           <div class="responsive-tabs">
                              <ul class="nav nav-tabs" role="tablist">
                                 <li class="nav-item">
                                    <a id="tab-A" href="#pane-A" class="nav-link active" data-bs-toggle="tab" role="tab">
                                       CONTACTO INICIAL
                                    </a>
                                 </li>
                                 <li class="nav-item">
                                    <a id="tab-B" href="#pane-B" class="nav-link" data-bs-toggle="tab" role="tab">
                                       SERVICIOS
                                    </a>
                                 </li>
                                 <li class="nav-item">
                                    <a id="tab-C" href="#pane-C" class="nav-link" data-bs-toggle="tab" role="tab">
                                       ASISTENCIA
                                    </a>
                                 </li>
                              </ul>

                              <div id="nav-tab-content" class="tab-content" role="tablist">
                                 <div id="pane-A" class="card tab-pane fade show active" role="tabpanel" aria-labelledby="tab-A">
                                    <div class="card-header" role="tab" id="heading-A">
                                       <h5 class="mb-0">
                                          <a data-bs-toggle="collapse" href="#collapse-A" aria-expanded="true" aria-controls="collapse-A">
                                             CONTACTO INICIAL
                                          </a>
                                       </h5>
                                    </div>
                                    <div id="collapse-A" class="collapse show" data-bs-parent="#nav-tab-content" role="tabpanel"
                                         aria-labelledby="heading-A">
                                       <div class="card-body">
                                          <h4>VIDEOLLAMADA</h4>
                                          <p>Mediante una videollamada de 30 minutos conoceremos los detalles de tu caso y tus planes para saber cómo comenzar a ayudarte.</p>
                                          <p>Cada caso es diferente por lo que necesitamos entender cuánta ayuda podrás necesitar.</p>
                                          <p>Ya sea que recientemente te has propuesto salir del país o bien si ya tienes tus planes y trámites en proceso, estaremos a tu lado para solucionar tu dudas, ofrecerte asesoría legal, conseguirte un seguro médico y más!</p>
                                       </div>
                                    </div>
                                 </div>

                                 <div id="pane-B" class="card tab-pane fade" role="tabpanel" aria-labelledby="tab-B">
                                     <div class="card-header" role="tab" id="heading-B">
                                         <h5 class="mb-0">
                                          <a class="collapsed" data-bs-toggle="collapse" href="#collapse-B" aria-expanded="false" aria-controls="collapse-B">
                                             SERVICIOS
                                          </a>
                                       </h5>
                                    </div>
                                    <div id="collapse-B" class="collapse" data-bs-parent="#nav-tab-content" role="tabpanel"
                                         aria-labelledby="heading-B">
                                       <div class="card-body">
                                          <h4>SERVICIOS PERSONALIZADOS</h4>
                                          <p>
                                             Al elegir nuestra consultoría, accederás a un abanico de servicios diseñados para hacer éste proceso lo más fluido y claro posible.
                                          </p>
                                          <h5>Nuestros servicios incluyen:</h5>
                                          <p>Planificación de Viajes: Organizamos con vos todos los preparativos personalizados para que su experiencia de viaje sea inolvidable, desde la elección de destinos hasta la reserva de alojamientos y transporte.</p>
                                          <p>Gestión de Visados y Documentación: asistencia en la compleja tramitación de visados y otros documentos necesarios para la estancia en Europa, asegurando que se cumplen con todos los requisitos legales sin complicaciones.</p>
<!--                                           <p>Programas de Estudio y Becas: Ofrecemos orientación detallada sobre las opciones de estudio, incluyendo la elección de instituciones académicas y la solicitud de becas para maximizar sus oportunidades educativas.</p>
-->                                       <p>Oportunidades Laborales:  Te ayudamos a navegar el mercado laboral europeo con asesoramiento sobre búsqueda de empleo, redacción de CVs y preparación para entrevistas para aumentar sus posibilidades de éxito profesional.</p>
                                          <p>Alojamiento y Establecimiento: Facilitamos la búsqueda de un hogar en Europa, proporcionando opciones que se ajusten a sus necesidades y presupuesto.</p>
                                          <p>Soporte Continuo: Una vez en Europa, seguimos a su lado con asistencia continua para asegurar que su adaptación al nuevo entorno sea lo más suave posible.</p>
                                          <p>En VoyJaleas, estamos comprometidos con hacer de tu aventura europea una realidad exitosa y gratificante. Contactá hoy para empezar a planificar tu futuro en Europa.</p>
                                       </div>
                                    </div>
                                 </div>

                                 <div id="pane-C" class="card tab-pane fade" role="tabpanel" aria-labelledby="tab-C">
                                    <div class="card-header" role="tab" id="heading-C">
                                       <h5 class="mb-0">
                                          <a data-bs-toggle="collapse" href="#collapse-C" aria-expanded="true" aria-controls="collapse-C">
                                             ASISTENCIA
                                          </a>
                                       </h5>
                                    </div>
                                    <div id="collapse-C" class="collapse" data-bs-parent="#nav-tab-content" role="tabpanel"
                                         aria-labelledby="heading-C">
                                       <div class="card-body">
                                          <h4>CONSULTORÍA Y ASISTENCIA
                                          </h4>
                                          <p>
                                             Ofrecemos un servicio integral, utilizando herramientas digitales avanzadas para garantizar que tu transición sea fluida y libre de estrés. A través de nuestra webapp, videollamadas, email y un grupo exclusivo de WhatsApp, estamos equipados para asistirte en cada paso de tu viaje.
                                          </p>
                                          <h5>Explore nuestros servicios digitales:</h5>
                                          <p>Webapp Personalizada: Acceda a nuestra plataforma en línea donde podrá gestionar todos los aspectos de su viaje y estancia en Europa. Desde aquí, puede consultar recursos, realizar trámites y mantenerse informado de las últimas novedades y requisitos legales.</p>
                                          <p>Videollamadas Programadas: sesiones de asesoramiento y soporte con nuestros expertos, quienes proporcionarán orientación detallada y respuestas en tiempo real a todas tus inquietudes.</p>
                                          <p>Comunicación Continua por Email: contacto constante con nuestro equipo a través de emails. Ya sea para resolver dudas puntuales o recibir actualizaciones importantes, estamos a un correo de distancia.</p>
                                          <p>Grupo de WhatsApp Dedicado: Únase a nuestra comunidad en WhatsApp, donde podrás interactuar con otros clientes y recibir asistencia colectiva. Este espacio está diseñado para compartir experiencias, consejos y recibir soporte grupal de manera rápida y eficiente.</p>
                                          <p>En VoyJaleas, utilizamos la tecnología para acercarnos más a vos, adaptándonos a tus necesidades y horarios para proporcionar una experiencia personalizada y accesible. Contactá hoy mismo para descubrir cómo podemos ayudarle a hacer realidad tu sueño europeo con el apoyo continuo que merecés.</p>
                                       </div>
                                    </div>
                                 </div>
                             </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  
               </div>
            </div>
         </div>

          <!-- ***Home destination html end here*** -->
          <!-- ***Home package html start from here*** -->
         
         <app-product-offer></app-product-offer>

         <app-package-offer></app-package-offer>

          <!-- ***Home package html end here*** -->
          <!-- ***Home callback html start from here*** -->
          <!-- <section class="home-callback bg-img-fullcallback" style="background-image: url(assets/images/img7.jpg);">
             <div class="overlay"></div>
             <div class="container">
                <div class="row">
                   <div class="col-lg-8 offset-lg-2 text-center">
                      <div class="callback-content">
                         <div class="video-button">
                            <a  id="video-container" data-fancybox="video-gallery" href="https://www.youtube.com/watch?v=2OYar8OHEOU">
                               <i class="fas fa-play"></i>
                            </a>
                         </div>
                         <h2 class="section-title">TU PUENTE HACIA NUEVAS EXPERIENCIAS EN EUROPA!</h2>
                         <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                         <div class="callback-btn">
                            <a href="package.html" class="round-btn">View Packages</a>
                            <a href="about.html" class="outline-btn outline-btn-white">Learn More</a>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </section> -->
          <!-- ***Home callback html end here*** -->
          <!-- ***Home counter html start from here*** -->
          <!-- <div class="home-counter">
             <div class="container">
                <div class="counter-wrap">
                   <div class="counter-item">
                      <span class="counter-no">
                         <span class="counter">80</span>K+
                      </span>
                      <span class="counter-desc">
                         SATISFIED CUSTOMER
                      </span>
                   </div>
                   <div class="counter-item">
                      <span class="counter-no">
                         <span class="counter">18</span>+
                      </span>
                      <span class="counter-desc">
                         ACTIVE MEMBERS
                      </span>
                   </div>
                   <div class="counter-item">
                      <span class="counter-no">
                         <span class="counter">220</span>+
                      </span>
                      <span class="counter-desc">
                         TOUR DESTINATION
                      </span>
                   </div>
                   <div class="counter-item">
                      <span class="counter-no">
                         <span class="counter">75</span>+
                      </span>
                      <span class="counter-desc">
                         TRAVEL GUIDES
                      </span>
                   </div>
                </div>
             </div>
          </div> -->
          <!-- ***Home counter html end here*** -->
          <!-- ***Home offer html start from here*** -->

          <app-webapp-banner></app-webapp-banner>

          <!-- ***Home offer html end here*** -->
          <!-- ***Home gallery html start from here*** -->
          <!-- <section class="home-gallery">
             <div class="container">
                <div class="row">
                   <div class="col-lg-8 offset-lg-2 text-sm-center">
                      <div class="section-heading">
                         <h5 class="sub-title">PHOTO GALLERY</h5>
                         <h2 class="section-title">PHOTO'S FROM TRAVELLERS</h2>
                         <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                      </div>
                   </div>
                </div>
                <div class="gallery-section">
                   <div class="gallery-container grid">
                      <div class="single-gallery grid-item">
                         <figure class="gallery-img">
                            <a href="assets/images/img14.jpg" data-fancybox="gallery">
                               <img src="assets/images/img14.jpg" alt="">
                            </a>
                         </figure>
                      </div>
                      <div class="single-gallery grid-item">
                         <figure class="gallery-img">
                            <a href="assets/images/img11.jpg" data-fancybox="gallery">
                               <img src="assets/images/img11.jpg" alt="">
                            </a>
                         </figure>
                      </div>
                      <div class="single-gallery grid-item">
                         <figure class="gallery-img">
                            <a href="assets/images/img12.jpg" data-fancybox="gallery">
                               <img src="assets/images/img12.jpg" alt="">
                            </a>
                         </figure>
                      </div>
                      <div class="single-gallery grid-item">
                         <figure class="gallery-img">
                            <a href="assets/images/img13jpg" data-fancybox="gallery">
                               <img src="assets/images/img13.jpg" alt="">
                            </a>
                         </figure>
                      </div>
                      <div class="single-gallery grid-item">
                         <figure class="gallery-img">
                            <a href="assets/images/img10.jpg" data-fancybox="gallery">
                               <img src="assets/images/img10.jpg" alt="">
                            </a>
                         </figure>
                      </div>
                   </div>
                </div>
             </div>
          </section> -->
          
          <!-- <section class="home-client client-section" style="background-image: url(assets/images/banner-img1.jpg);">
             <div class="container">
                <div class="row align-items-center">
                   <div class="col-lg-6">
                      <div class="client-content">
                         <h5 class="sub-title">DISCOUNT OFFER</h5>
                         <h2 class="section-title">GET SPECIAL DISCOUNT ON SIGN UP !</h2>
                         <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantm sit.</p>
                         <a href="contact.html" class="round-btn">Sign Up Now</a>
                      </div>
                   </div>
                   <div class="col-lg-6">
                      <div class="client-logo">
                         <ul>
                            <li>
                               <img src="assets/images/client-img1.png" alt="">
                            </li>
                            <li>
                               <img src="assets/images/client-img2.png" alt="">
                            </li>
                            <li>
                               <img src="assets/images/client-img3.png" alt="">
                            </li>
                            <li>
                               <img src="assets/images/client-img4.png" alt="">
                            </li>
                            <li>
                               <img src="assets/images/client-img5.png" alt="">
                            </li>
                            <li>
                               <img src="assets/images/client-img6.png" alt="">
                            </li>
                         </ul>
                      </div>
                   </div>
                </div>
             </div>
             <div class="overlay"></div>
          </section> -->

          <!-- <section class="home-blog">
             <div class="container">
                <div class="section-heading d-sm-flex align-items-center justify-content-between">
                   <div class="heading-group">
                      <h5 class="sub-title">LATEST BLOG</h5>
                      <h2 class="section-title">OUR RECENT POSTS</h2>
                      <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. <br/>Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                   </div>
                   <div class="heading-btn">
                      <a href="blog-archive.html" class="round-btn">View All Blog</a>
                   </div>
                </div>
                <div class="blog-section">
                   <div class="row gx-4">
                      <div class="col-lg-6">
                         <article class="post">
                            <figure class="featured-post" style="background-image: url(assets/images/img16.jpg);"></figure>
                            <div class="post-content">
                               <div class="cat-meta">
                                  <a href="blog-archive.html">TOUR</a>
                               </div>
                               <h3><a href="blog-single.html">BEST JOURNEY TO PEACEFUL PLACES</a></h3>
                               <p>Laboris hac erat dolor, posuere volutpat fringilla gravida metus nonummy, blandit mi...</p>
                               <div class="post-footer d-flex justify-content-between align-items-center">
                                  <div class="post-btn">
                                     <a href="blog-single.html" class="round-btn">Read More</a>
                                  </div>
                                  <div class="meta-comment">
                                     <a href="blog-archive.html">
                                        <i aria-hidden="true" class="fas fa-comment"></i>
                                        <span>0</span>
                                     </a>
                                  </div>
                               </div>
                            </div>
                         </article>
                      </div>
                      <div class="col-lg-6">
                         <article class="post">
                            <figure class="featured-post" style="background-image: url(assets/images/img17.jpg);"></figure>
                            <div class="post-content">
                               <div class="cat-meta">
                                  <a href="blog-archive.html">TRAVEL</a>
                               </div>
                               <h3><a href="blog-single.html">BTRAVEL WITH FRIENDS IS BEST</a></h3>
                               <p>Laboris hac erat dolor, posuere volutpat fringilla gravida metus nonummy, blandit mi...</p>
                               <div class="post-footer d-flex justify-content-between align-items-center">
                                  <div class="post-btn">
                                     <a href="blog-single.html" class="round-btn">Read More</a>
                                  </div>
                                  <div class="meta-comment">
                                     <a href="blog-archive.html">
                                        <i aria-hidden="true" class="fas fa-comment"></i>
                                        <span>0</span>
                                     </a>
                                  </div>
                               </div>
                            </div>
                         </article>
                      </div>
                   </div>
                </div>
             </div>
          </section> -->

         <!--  <section class="home-gallery">
            <div class="container">
               <div class="row">
                  <div class="col-lg-8 offset-lg-2 text-sm-center">
                     <div class="section-heading">
                        <h5 class="sub-title">11 años de</h5>
                        <h2 class="section-title">MI CAMINO POR EUROPA </h2>
                        <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                     </div>
                  </div>
               </div>
               <div class="gallery-section">
                  <div class="gallery-container grid">
                     <div class="single-gallery grid-item">
                        <figure class="gallery-img">
                           <a href="assets/images/img14.jpg" data-fancybox="gallery">
                              <img src="assets/images/img14.jpg" alt="">
                           </a>
                        </figure>
                     </div>
                     <div class="single-gallery grid-item">
                        <figure class="gallery-img">
                           <a href="assets/images/img11.jpg" data-fancybox="gallery">
                              <img src="assets/images/img11.jpg" alt="">
                           </a>
                        </figure>
                     </div>
                     <div class="single-gallery grid-item">
                        <figure class="gallery-img">
                           <a href="assets/images/img12.jpg" data-fancybox="gallery">
                              <img src="assets/images/img12.jpg" alt="">
                           </a>
                        </figure>
                     </div>
                     <div class="single-gallery grid-item">
                        <figure class="gallery-img">
                           <a href="assets/images/img13jpg" data-fancybox="gallery">
                              <img src="assets/images/img13.jpg" alt="">
                           </a>
                        </figure>
                     </div>
                     <div class="single-gallery grid-item">
                        <figure class="gallery-img">
                           <a href="assets/images/img10.jpg" data-fancybox="gallery">
                              <img src="assets/images/img10.jpg" alt="">
                           </a>
                        </figure>
                     </div>
                  </div>
               </div>
            </div>
         </section> -->

          <div #testimonial></div>
          <section >
            <div class="container" style="padding: 3rem;">
               <div class="row">
               </div>
            </div>
          </section>
          <section class="home-testimonial">
             <div class="container">
                <div class="row">
                   <div class="col-lg-8 offset-lg-2 text-center">
                      <div class="section-heading">
                         <h5 class="sub-title">LO QUE PIENSAN NUESTROS CLIENTES</h5>
                         <h2 class="section-title">CASOS DE ÉXITO</h2>
                         <p>
                           Inspiráte con los testimonios de quienes, como vos, tomaron la decisión de embarcarse en una nueva vida en Europa con nuestra ayuda. Éstas historias son la prueba de que, con el soporte adecuado, cualquier transición puede ser una experiencia enriquecedora y exitosa.
                         </p>
                      </div>
                   </div>
                </div>
                <div class="testimonial-section testimonial-slider">
                   <div class="testimonial-item" *ngFor="let test of testimonials">
                      <div class="testimonial-content">
                         <!-- <div class="rating-start-wrap">
                            <div class="rating-start">
                               <span style="width: 80%"></span>
                            </div>
                         </div> -->
                         <p>{{test.testimonial}}</p>
                         <div class="author-content">
                            <figure class="testimonial-img">
                               <img [src]="test.imageUrl" alt="">
                            </figure>
                            <div class="author-name">
                               <h5>{{test.name}}</h5>
                               <span>{{test.career}}</span>
                            </div>
                         </div>
                         <div class="testimonial-icon">
                            <i aria-hidden="true" class="fas fa-quote-left" style="color: lightgray;"></i>
                         </div>
                      </div>
                   </div>
                   
                </div>
             </div>
          </section>

          <section class="home-callback bg-color-callback primary-bg">
             <div class="container">
                <div class="row align-items-center">
                   <div class="col-md-8">
                      <h5 class="sub-title">RESERVA TU VIDEOLLAMADA GRATUITA Y </h5>
                      <h2 class="section-title">COMENCEMOS A PLANEAR TU AVENTURA!!</h2>
                      <p>Nos encantaría conocerte y escuchar tu historia. Agendá una llamada con nuestro equipo para hablar sobre tus necesidades.</p>
                   </div>
                   <div class="col-md-4 text-md-end">
                      <a href="javascript:void(0)" (click)="goToCalendly()" class="outline-btn outline-btn-white">RESERVAR VIDEOLLAMADA</a>
                   </div>
                </div>
             </div>
          </section>
          <!-- ***Home callback html end here*** -->
       </main>
       <!-- ***site footer html start form here*** -->
       <app-smart-footer></app-smart-footer>

       <!-- ***site footer html end*** -->
       <a id="backTotop" href="#" class="to-top-icon">
          <i class="fas fa-chevron-up"></i>
       </a>
       <!-- ***custom search field html*** -->
       <div class="header-search-form">
          <div class="container">
             <div class="header-search-container">
                <form class="search-form" role="search" method="get" >
                   <input type="text" name="s" placeholder="Enter your text...">
                </form>
                <a href="#" (click)="goToPage('home')" class="search-close">
                   <i class="fas fa-times"></i>
                </a>
             </div>
          </div>
       </div>
       <!-- ***custom search field html*** -->
       <!-- ***custom top bar offcanvas html*** -->
       <div id="offCanvas" class="offcanvas-container">
          <div class="offcanvas-inner">
             <div class="offcanvas-sidebar">
                <aside class="widget author_widget">
                   <h3 class="widget-title">OUR PROPRIETOR</h3>
                   <div class="widget-content text-center"> 
                      <div class="profile"> 
                         <figure class="avatar"> 
                            <img src="assets/images/img21.jpg" alt=""> 
                         </figure> 
                         <div class="text-content"> 
                            <div class="name-title"> 
                               <h4> James Watson</h4> 
                            </div> 
                            <p>Accumsan? Aliquet nobis doloremque, aliqua? Inceptos voluptatem, duis tempore optio quae animi viverra distinctio cumque vivamus, earum congue, anim velit</p> 
                         </div> 
                         <div class="socialgroup"> 
                            <ul> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-facebook"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-google"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-twitter"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-instagram"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-pinterest"></i> </a> </li> 
                            </ul> 
                         </div> 
                      </div> 
                   </div>
                </aside>
                <aside class="widget widget_text text-center">
                   <h3 class="widget-title">CONTACT US</h3>
                   <div class="textwidget widget-text">
                      <p>Feel free to contact and<br/> reach us !!</p>
                      <ul>
                         <li>
                            <a href="tel:+01988256203">
                               <i aria-hidden="true" class="icon icon-phone1"></i>
                               +01(988) 256 203
                            </a>
                         </li>
                         <li>
                            <a href="mailtop:info@domain.com">
                               <i aria-hidden="true" class="icon icon-envelope1"></i>
                               info@domain.com
                            </a>
                         </li>
                         <li>
                            <i aria-hidden="true" class="icon icon-map-marker1"></i>
                            3146 Koontz, California
                         </li>
                      </ul>
                   </div>
                </aside>
             </div>
             <a href="#" (click)="goToPage('home')" class="offcanvas-close">
                <i class="fas fa-times" (click)="goToPage('home')"></i>
             </a>
          </div>
          <div class="overlay"></div>
       </div>
       <!-- ***custom top bar offcanvas html*** -->
    </div>

  
 </body>